import useSWR from "swr"

const retriever = async (url: string): Promise<string> => {
  const response = await fetch(url)
  if (!response.ok) {
    throw new Error(
      `Failed to fetch file: ${response.status} ${response.statusText}`,
    )
  }
  return response.text()
}

export const useConsentFile = (url: string) => useSWR<string>(
  url,
  retriever,
)
